import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import MoneyIcon from "@material-ui/icons/Money";
import DescriptionIcon from "@material-ui/icons/Description";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _EconomicDataForm, _InfoSection } from "../components";

export interface IRouteParam {
    ID_Anag: string;
    ID_DatoEconomico: string;
    ID_FideAffidamento?: string;
}

export const _EconomicData: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Anag = Number(useParams<IRouteParam>().ID_Anag) || 0;
    const ID_DatoEconomico = Number(useParams<IRouteParam>().ID_DatoEconomico) || 0;
    const ID_FideAffidamento = Number(useParams<IRouteParam>().ID_FideAffidamento) || 0;

    useEffect(() => {
        if (!Glob.AzioneAbilitata("DatiEconomiciController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    useEffect(() => {
        const ID_MenuMain = ID_DatoEconomico || ID_FideAffidamento ? 24 : 0;
        let VariabiliMenu = {};

        if (ID_FideAffidamento) {
            VariabiliMenu = { ["{ID_FideAffidamento}"]: ID_FideAffidamento };
        }
        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain, VariabiliMenu });
    }, [ID_DatoEconomico, ID_FideAffidamento]);

    const baseURL = `/anagrafica/${ID_Anag}${ID_FideAffidamento ? `/fideaffidamento/${ID_FideAffidamento}` : ""}/DatiEconomici`;

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={MoneyIcon} Title="Dati economici">
                    {!!ID_DatoEconomico && (
                        <a href={`/file/${ID_DatoEconomico}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="add">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                    {Glob.AzioneAbilitata("DatiEconomiciController", Glob.Scrittura) && (
                        <NavLink to={`${baseURL}/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoSection DataUrl={`/api/anag/Contesto?ID_Anag=${ID_Anag}`} LinkUrl={`/anagrafica/${ID_Anag}`} Title="Anagrafica" />
                        </Grid>
                        <Grid item xs={12}>
                            <_EconomicDataForm ID_Anag={ID_Anag} ID_DatoEconomico={ID_DatoEconomico} BaseURL={baseURL} />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/EconomicData.tsx